module.exports = __webpack_public_path__ + "static/media/minimap.a2a4ae82.gif";